import { passkeyKey } from '../state/storageKey';
import { twMerge } from 'tailwind-merge'
import { ClassValue, clsx } from 'clsx'

export const setPassKey = (key: string) => {
  try {
    localStorage.setItem(passkeyKey, key);
  } catch (e) {
    // do something
  }
};

export const removePassKey = () => {
  try {
    localStorage.removeItem(passkeyKey);
  } catch (e) {
    // do something
  }
};

export function generateRandomString(length: number): string {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  return result;
}

export async function hashWithWebCrypto(message: string) {
  const msgBuffer = new TextEncoder().encode(message);

  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

  return hashHex;
}

export async function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function validEmail(str: string) {
  return /^[\w-\.]+@([\w-]+\.)+[\w-]+$/.test(str)
}
